import checkout from "./form";

const {
  formField: {
    accountOwner,
    bankAccountNumber,
    bankName,
    certificateNumber,
    chiefAccountant,
    documentNumber,
    signer,
    taxAgentCode,
    taxAgentName,
    taxCode,
    taxPayers,
    timeSign,
    whyRefund,
    sendTo,
    attachDocument,
    taxRefundAfter,
    taxRefundBefore,
    //
    dateRange,
    identifier,
    issuedBy,
    taxpayerCountry,
  },
} = checkout;

const initialValues = {
  [accountOwner.name]: "",
  [attachDocument.name]: "",
  [bankAccountNumber.name]: "",
  [bankName.name]: "",
  [certificateNumber.name]: "",
  [chiefAccountant.name]: "",
  [documentNumber.name]: "",
  [taxAgentCode.name]: "",
  [signer.name]: "",
  [taxAgentName.name]: "",
  [taxCode.name]: "",
  [taxPayers.name]: "",
  [whyRefund.name]: "",
  [timeSign.name]: "",
  [sendTo.name]: "",
  [taxRefundAfter.name]: "",
  [taxRefundBefore.name]: "",
  [dateRange.name]: "",
  [identifier.name]: "",
  [issuedBy.name]: "",
  [taxpayerCountry.name]: "",
};

export default initialValues;
